module.exports = __webpack_public_path__ + "img/android.ac22419b.png";